import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import firebase from 'firebase'
import moment from 'moment'
import router from './router'
import 'sweetalert2/dist/sweetalert2.min.css'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
  // restoreState
})

export default new Vuex.Store({
  state: {
    locale: 'en',
    tabIndex: null,
    licensesCategory: null,
    users: [],
    categories: [],
    groups: [],
    licenses: {},
    systemAdmins: [],
    companies: [],
    settings: {},
    company: {},
    userPreferences: null,
    user: {
      loggedIn: false,
      data: null
    },
    token: null
  },
  getters: {
    user (state) {
      return state.user
    }
  },
  mutations: {
    RESET_STATE (state, value) {
      state.users = []
      state.categories = []
      state.companies = []
      state.licenses = {}
      state.user = {}
      state.company = {}
      state.systemAdmins = []
      state.settings = {}
    },
    GET_SYSTEM_ADMINS (state, data) {
      let index = state.systemAdmins.findIndex(m => m.id === data.id)
      // console.log(index)
      if (index > -1) {
        state.systemAdmins[index] = data
      } else {
        state.systemAdmins.push(data)
      }
    },
    SET_LOGGED_IN (state, data) {
      state.user.loggedIn = data
    },
    SET_USER (state, data) {
      state.user.data = data
    },
    GET_USERS (state, data) {
      let index = state.users.findIndex(m => m.id === data.id)
      if (index > -1) {
        state.users[index] = data
      } else {
        state.users.push(data)
      }
    },
    GET_LICENSES (state, data) {
      let index = -1
      // console.log(state)
      if (state.licenses[data.companyId]) {
        index = state.licenses[data.companyId].findIndex(m => m.id === data.id)
      } else {
        Vue.set(state.licenses, data.companyId, [])
        // state.licenses[data.companyId] = []
      }
      if (index > -1) {
        state.licenses[data.companyId][index] = data
      } else {
        state.licenses[data.companyId].push(data)
      }
      // console.log(state.licenses)
    },
    GET_COMPANIES (state, data) {
      let index = state.companies.findIndex(m => m.id === data.id)
      if (index > -1) {
        state.companies[index] = data
      } else {
        state.companies.push(data)
      }
    },
    GET_CATEGORY (state, data) {
      let index = state.categories.findIndex(m => m.id === data.id)
      if (index > -1) {
        state.categories[index] = data
      } else {
        state.categories.push(data)
      }
    },
    GET_GROUPS (state, data) {
      let index = state.groups.findIndex(m => m.id === data.id)
      if (index > -1) {
        state.groups[index] = data
      } else {
        state.groups.push(data)
      }
    },
    GET_COMPANY (state, data) {
      state.company = data
    },
    GET_COMPANY_PREFERENCES (state, data) {
      state.companyPreferences = data
    },
    GET_USER_PREFERENCES (state, data) {
      state.userPreferences = data
    },
    REMOVE_USER (state, index) {
      state.users.splice(index, 1)
    },
    SET_LOCALE (state, lang) {
      state.locale = lang
    }
  },
  actions: {
    setLocale ({ commit }, lang) {
      commit('SET_LOCALE', lang)
    },
    resetState ({ commit }, user) {
      commit('RESET_STATE', null)
    },
    removeUser ({ dispatch, commit }, id) {
      var index = this.state.users.findIndex(u => u.id === id)
      commit('REMOVE_USER', index)
    },
    fetchUser ({ dispatch, commit }, user) {
      commit('SET_LOGGED_IN', user !== null)
      if (user) {
        let userQuery = firebase.firestore().collection('users').doc(user.uid)
        userQuery.get().then(doc => {
          if (doc) {
            let user = doc.data()
            if (!['System Admin', 'Administrator', 'Manager', 'Supervisor'].includes(user.role) || user.status !== 'Active') {
              dispatch('logOut')
            } else {
              if (router.app._route.name === 'LogIn') {
                if (user.role !== 'System Admin') {
                  router.push({name: 'Categories'})
                } else {
                  router.push({name: 'Dashboard'})
                }
              }
              if (user.role !== 'System Admin') {
                dispatch('fetchUserPreferences', doc.id)
              }
              commit('SET_USER', user)
              dispatch('fetchCompany')
            }
            // console.log('setting User')
          }
        })
      } else {
        commit('SET_USER', null)
      }
    },
    logOut ({ dispatch, commit }) {
      firebase
        .auth()
        .signOut()
        .then(() => {
          Vue.swal({
            title: 'You are not allowed to access this panel! \n Contact your administrator.',
            type: 'error',
            timer: 0,
            showConfirmButton: false,
            confirmButtonColor: '#00aeef'
          })
        })
      dispatch('resetState')
    },
    fetchSystemAdmins ({ commit }) {
      firebase.firestore().collection('users').where('role', '==', 'System Admin').get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            // doc.data() is never undefined for query doc snapshots
            var user = doc.data()
            user.id = doc.id
            if (user.createdAt != null) {
              user.createdAt = moment(String(user.createdAt.toDate())).format('DD/MM/YYYY kk:mm')
            }
            // console.log(user.createdAt)
            commit('GET_SYSTEM_ADMINS', user)
          })
        })
    },
    async fetchUsers ({ commit }) {
      await firebase.firestore().collection('users').where('companyId', '==', this.state.user.data.companyId).get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            // doc.data() is never undefined for query doc snapshots
            var user = doc.data()
            user.id = doc.id
            if (user.createdAt != null) {
              user.createdAt = moment(String(user.createdAt.toDate())).format('DD/MM/YYYY kk:mm')
            }
            // console.log(user.createdAt)
            commit('GET_USERS', user)
          })
        })
    },
    async syncUser ({ commit }, id) {
      await firebase.firestore().collection('users').doc(id).get()
        .then(function (doc) {
          var user = doc.data()
          user.id = doc.id
          if (user.createdAt != null) {
            user.createdAt = moment(String(user.createdAt.toDate())).format('DD/MM/YYYY kk:mm')
          }
          // console.log(user.createdAt)
          commit('GET_USERS', user)
        })
    },
    fetchCompanies ({ commit }) {
      firebase.firestore().collection('companies').get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(async function (doc) {
            // doc.data() is never undefined for query doc snapshots
            var companyData = doc.data()
            if (companyData.createdAt != null) {
              companyData.createdAt = moment(String(companyData.createdAt.toDate())).format('DD/MM/YYYY')
            }
            companyData.id = doc.id
            if (companyData.admin) {
              await firebase.firestore().collection('users').doc(companyData.admin).get()
                .then(doc => {
                  let admin = doc.data()
                  if (admin) {
                    companyData.adminName = admin.firstName + ' ' + admin.lastName
                  }
                })
            }
            // console.log(user.createdAt)
            // companies.push(companyData)
            commit('GET_COMPANIES', companyData)
          })
        })
    },
    async fetchCompanyPreferences ({ commit }, companyId) {
      let res = await firebase.firestore().doc('companies/' + companyId + '/settings/preferences').get()
      let data = res.data()
      commit('GET_COMPANY_PREFERENCES', data)
      return data
    },
    async fetchUserPreferences ({ commit }, userId) {
      let res = await firebase.firestore().doc('users/' + userId + '/settings/preferences').get()
      if (res.exists) {
        let data = res.data()
        commit('GET_USER_PREFERENCES', data)
        return data
      }
      return null
    },
    async fetchCompany ({ dispatch, commit }) {
      let company = this.state.user.data.companyId
      if (company) {
        let companyObj = await firebase.firestore().doc('companies/' + company)
        companyObj.get().then(function (doc) {
          var companyData = doc.data()
          if (companyData.status !== 'Active') {
            dispatch('logOut')
          }
          commit('GET_COMPANY', companyData)
          dispatch('fetchLicenses', company)
          dispatch('fetchCompanyPreferences', doc.id)
        })
      }
    },
    async fetchLicenses ({ dispatch, commit }, companyId) {
      let companyObj
      // console.log('companyId', companyId)
      companyObj = await firebase.firestore().collection('companies').doc(companyId).collection('licenses')
      companyObj.get().then(function (querySnapshot) {
        querySnapshot.forEach(async function (doc) {
          var data = doc.data()
          // console.log('licenseData.expiryDate', data)
          data.id = doc.id
          if (data.expiryDate != null) {
            var expiration = moment(data.expiryDate.toDate(), 'DD/MM/YYY')
            var currentDate = moment()
            if (moment(expiration).isBefore(currentDate, 'days')) {
              data.status = 'Expired'
            } else {
              data.status = 'Active'
            }
            data.expiryDate = moment(String(data.expiryDate.toDate())).format('DD/MM/YYYY')
          }
          commit('GET_LICENSES', data)
        })
      })
    },
    async fetchGroups ({dispatch, commit}) {
      this.state.groups = []
      var groups = await firebase.firestore().collection('companies').doc(this.state.user.data.companyId).collection('groups')

      groups.get().then(function (querySnapshot) {
        querySnapshot.forEach(async function (doc) {
          var groupData = doc.data()
          groupData.id = doc.id
          if (groupData.createdAt != null) {
            groupData.createdAt = moment(String(groupData.createdAt.toDate())).format('DD/MM/YYYY hh:mm')
          }
          commit('GET_GROUPS', groupData)
        })
      })
    },
    async fetchCategories ({dispatch, commit}) {
      this.state.categories = []
      var categories
      if (this.state.user.data.role === 'Manager') {
        var managerObj = {managerId: this.state.user.data.uid, managerName: this.state.user.data.firstName + ' ' + this.state.user.data.lastName}
        categories = await firebase.firestore().collection('companies').doc(this.state.user.data.companyId).collection('categories').where('managers', 'array-contains', managerObj)
      } else if (this.state.user.data.role === 'Supervisor') {
        let groups = await firebase.firestore().collection('companies').doc(this.state.user.data.companyId).collection('groups').where('users', 'array-contains', this.state.user.data.uid).get()
        let userCategories = []
        groups.docs.forEach(group => {
          const groupData = group.data()
          if (groupData.hasOwnProperty('categoryId')) {
            userCategories.push(groupData.categoryId)
          }
        })
        console.log('categoriessssss', userCategories)
        // TODO ONLY 10 categories can be in the IN comparison
        categories = await firebase.firestore().collection('companies').doc(this.state.user.data.companyId).collection('categories').where(firebase.firestore.FieldPath.documentId(), 'in', userCategories)
      } else {
        categories = await firebase.firestore().collection('companies').doc(this.state.user.data.companyId).collection('categories')
      }
      categories.get().then(function (querySnapshot) {
        querySnapshot.forEach(async function (doc) {
          var categoryData = doc.data()
          categoryData.id = doc.id
          if (!categoryData.hasOwnProperty('name')) {
            categoryData.name = doc.id
          }
          if (categoryData.createdAt != null) {
            categoryData.createdAt = moment(String(categoryData.createdAt.toDate())).format('DD/MM/YYYY kk:mm')
          }
          // console.log('fxetched category:', categoryData)
          commit('GET_CATEGORY', categoryData)
        })
      })
    },
    async searchLabels ({ dispatch, commit }, data) {
      var labels = []
      let labelsQuery
      var diffDays = null
      labelsQuery = await firebase.firestore().collection('companies').doc(data.companyId).collection('groups').doc(data.groupId).collection('labels')
      for (var filter in data.filters) {
        var sortField = 'createdAt'
        if (['LABELLING', 'BLAST_CHILLER', 'TEMPERATURE', 'ALLERGEN', 'INGREDIENTS'].includes(data.filters['labelType'])) {
          sortField = 'dateIn'
        }

        if (data.filters[filter] != null && data.filters[filter] !== '') {
          // console.log(filter, data.filters[filter])

          if (['dateRange'].includes(filter)) {
            console.log('filter.start', data.filters[filter].start)
            let startDate = new Date(data.filters[filter].start)
            let endDate = new Date(data.filters[filter].end)
            endDate.setHours(24, 0, 0)
            console.log('filter.start', startDate)

            labelsQuery = labelsQuery.where(sortField, '>=', startDate)
            labelsQuery = labelsQuery.where(sortField, '<=', endDate)
            // }
          } else if (filter === 'users') {
            if (data.filters[filter].length > 0) {
              var users = []
              data.filters[filter].forEach(user => {
                users.push(user.value)
              })
              labelsQuery = labelsQuery.where('userId', 'in', users)
            }
          } else if (filter === 'keyword') {
            labelsQuery = labelsQuery.where('search', 'array-contains', data.filters[filter])
          } else {
            if (filter === 'applianceNumber') {
              labelsQuery = labelsQuery.where(filter, '==', parseInt(data.filters[filter]))
            } else {
              labelsQuery = labelsQuery.where(filter, '==', data.filters[filter])
            }
          }
        }
      }
      console.log('diffDays1', diffDays)
      // if (diffDays !== 0) {
      labelsQuery = labelsQuery.orderBy(sortField, 'desc')
      // }
      if (data.lastVisible) {
        labelsQuery = labelsQuery.startAfter(data.lastVisible)
      }
      return labelsQuery.limit(20).get().then(function (querySnapshot) {
        if (querySnapshot.docs.length > 0) {
          var lastVisible = querySnapshot.docs[querySnapshot.size - 1]
        }
        firebase.analytics().logEvent('doc_fetch', {
          count: querySnapshot.docs.length,
          type: 'LABELS',
          company_id: data.companyId
        })
        /* eslint-disable */
        var timeOut = null
        querySnapshot.forEach(async function (doc) {
          var lblData = doc.data()
          lblData.id = doc.id
          lblData.label.forEach(field => {
            if (field.startsWith('TITLE.')) {
              lblData.title = field.replace('TITLE.', '')
            }
            if (field.startsWith('EXPIRY_DATETIME.')) {
              lblData.expiryDate = field.replace('EXPIRY_DATETIME.', '')
            }
            if (field.startsWith('DATE_OF_WEEK.')) {
              lblData.dayOut = field.replace('DATE_OF_WEEK.', '')
            }
            // if (field.startsWith('DATETIME_IN.')) {
            //   data.datetimeIn = field.replace('DATETIME_IN.', '')
            // }
            if (field.startsWith('TIME_OUT.')) {
              timeOut = field.replace('TIME_OUT.', '')
            }
            if (field.startsWith('INGREDIENTS.')) {
              lblData.ingredients = field.replace('INGREDIENTS.', '')
            }
          })
          // if (lblData.allergenCodes != null) {
          //   lblData.allergenCodes = lblData.allergenCodes
          // }
          // if (lblData.allergenOptions != null) {
          //   lblData.allergenOptions = lblData.allergenOptions.join(', ')
          // }
          if (lblData.dateIn != null) {
            lblData.dateIn = moment(String(lblData.dateIn.toDate())).format('DD/MM/YYYY kk:mm')
          }
          if (lblData.dateOut != null) {
            var oDateOut = moment(String(lblData.dateOut.toDate()))
            lblData.dateOut = oDateOut.format('DD/MM/YYYY kk:mm')
            // lblData.dayOut = oDateOut.format('dddd')
          }
          if (lblData.createdAt != null) {
            lblData.createdAt = moment(String(lblData.createdAt.toDate())).format('DD/MM/YYYY kk:mm')
          }
          labels.push(lblData)
        })
        return {labels: labels, lastVisible: lastVisible}
      })
    },
    async searchTemperatureLogs ({ dispatch, commit }, data) {
      var sensors = []
      let sensorsQuery
      console.log(data.groupId, data.filters.form)
      // sensorsQuery = await firebase.firestore().collection('companies').doc(data.companyId).collection('groups').doc(data.groupId).collection('forms').doc(data.filters.form).collection('submissions')
      sensorsQuery = await firebase.firestore().collectionGroup('temperatureLogs').where('group', '==', data.groupId)

      for (var filter in data.filters) {
        if (data.filters[filter] != null && data.filters[filter] !== '') {
          // console.log(filter, data.filters[filter])

          if (['dateRange'].includes(filter)) {

            let startDate = new Date(data.filters[filter].start)
            let endDate = new Date(data.filters[filter].end)
            endDate.setHours(24, 0, 0)

            // if (diffDays === 0) {
            //   labelsQuery = labelsQuery.where('createdAt', '==', startDate)
            // } else {


            sensorsQuery = sensorsQuery.where('timestamp', '>=', startDate)
            sensorsQuery = sensorsQuery.where('timestamp', '<=', endDate)
          } else {
            if (filter === "applianceNumber"){
              if(data.filters[filter] && data.filters[filter].length > 0) {
                sensorsQuery = sensorsQuery.where("applianceNumber", 'in', data.filters[filter])
              }
            } else if (data.filters[filter] != null) {
              sensorsQuery = sensorsQuery.where(filter, '==', data.filters[filter])
            }
          }
        }
      }
      // if (diffDays !== 0) {

      // }

      var limit = 100
      if(data.filters['dateRange'] != null){
        limit = 2000
      }

      return sensorsQuery.orderBy("timestamp", "desc").limit(limit).get().then(function (querySnapshot) {
        console.log(querySnapshot.docs.length)
        if (querySnapshot.docs.length > 0) {
          var lastVisible = querySnapshot.docs[querySnapshot.size - 1]
        }

        firebase.analytics().logEvent("doc_fetch", {
          count: querySnapshot.docs.length,
          type: "SENSORS",
          company_id: data.companyId
        })

        /* eslint-disable */
        querySnapshot.forEach(async function (doc) {
          var sensorData = doc.data()
          sensorData.id = doc.id
          sensorData.time =  moment(String(sensorData['timestamp'].toDate())).format('HH:mm')
          sensorData.date =  moment(String(sensorData['timestamp'].toDate())).format('DD/MM/YYYY')
          sensors.push(sensorData)
        })
        return {sensors: sensors, lastVisible: lastVisible}
      })
    },
    async searchFormResults ({ dispatch, commit }, data) {
      var forms = []
      let formsQuery = await firebase.firestore().collectionGroup('formResults').where('groupId', '==', data.groupId)
      for (var filter in data.filters) {
        if (data.filters[filter] != null && data.filters[filter] !== '') {
          // console.log(filter, data.filters[filter])

          if (['dateRange'].includes(filter)) {

            let startDate = new Date(data.filters[filter].start)
            let endDate = new Date(data.filters[filter].end)
            endDate.setHours(24, 0, 0)

            // if (diffDays === 0) {
            //   labelsQuery = labelsQuery.where('createdAt', '==', startDate)
            // } else {


            formsQuery = formsQuery.where('formDay', '>=', startDate)
            formsQuery = formsQuery.where('formDay', '<=', endDate)
          } else if (filter === 'users') {
            //todo
            // if (data.filters[filter].length > 0) {
            //   var users = []
            //   data.filters[filter].forEach(user => {
            //     users.push(user.value)
            //   })
            //   formsQuery = formsQuery.where('userId', 'in', users)
            // }
          } else {
            if (data.filters[filter] != null) {

              formsQuery = formsQuery.where(filter, '==', data.filters[filter])
            }
          }
        }
      }

      return formsQuery.orderBy('formDay', 'desc').orderBy('createdAt', 'desc').limit(31).get().then(function (querySnapshot) {

        firebase.analytics().logEvent("doc_fetch", {
          count: querySnapshot.docs.length,
          type: "FORM",
          company_id: data.companyId
        })

        if (querySnapshot.docs.length > 0) {
          var lastVisible = querySnapshot.docs[querySnapshot.size - 1]
        }
        /* eslint-disable */
        querySnapshot.forEach(function (doc) {
          var formData = doc.data()
          formData.id = doc.id
          formData.createdAtFormatted =  moment(String(formData.createdAt.toDate())).format('DD/MM/YYYY HH:mm')
          formData.formDayFormatted =  moment(String(formData.formDay.toDate())).format('DD/MM/YYYY')
          if (formData.hasOwnProperty("completedAt") && formData.completedAt != null){
            formData.completedAt =  moment(String(formData.completedAt.toDate())).format('DD/MM/YYYY HH:mm')
          }

          if (!formData.hasOwnProperty("status")) {
            formData.status = "COMPLETED"
          }

          var formResultsAr = []
          for (const key in formData.results) {


            if(formData.results[key].userId == null && formData.results[key].type !== 'NOTE') {
              console.log('formData.results[key]', formData.results[key])
              formData.results[key].valueLabel = ""

            } else {
              if (formData.results[key].hasOwnProperty("recordedAt") && formData.results[key].recordedAt !== null) {

                formData.results[key].recordedAtFormatted = moment(String(formData.results[key].recordedAt.toDate())).format('DD/MM/YYYY HH:mm')
              }

              switch (formData.results[key].type) {
                case 'TEMPERATURE':
                  formData.results[key].valueLabel = formData.results[key].value + ' ℃'
                  break
                case 'CHECKBOX':
                  formData.results[key].valueLabel = formData.results[key].value === true ? '<i class="fa fa-check text-success"></i>' : '<i class="fa fa-times text-danger"></i>'
                  break
                case 'WEIGHT':
                  formData.results[key].valueLabel = formData.results[key].value + ' kg'
                  break
                case 'DATETIME':
                  if(formData.results[key].value !== null) {
                    formData.results[key].valueLabel = moment(String(formData.results[key].value.toDate())).format('DD/MM/YYYY HH:mm')
                  } else {
                    formData.results[key].valueLabel = ""
                  }
                  break
                case 'DATE':
                  if(formData.results[key].value !== null) {
                    formData.results[key].valueLabel = moment(String(formData.results[key].value.toDate())).format('DD/MM/YYYY')
                  } else {
                    formData.results[key].valueLabel = ""
                  }
                  break
                case 'TIME':
                  if(formData.results[key].value !== null) {
                    formData.results[key].valueLabel = moment(String(formData.results[key].value.toDate())).format('HH:mm')
                  } else {
                    formData.results[key].valueLabel = ""
                  }
                    break
                case 'BARCODE':

                default:

                  break
              }
            }
            formResultsAr.push(formData.results[key])
          }
        //  console.log("formData.results", Object.keys(formData.results).sort((a,b) => a.order > b.order))


          formData.resultsArray = formResultsAr.sort(function(a, b){return a.order - b.order})
          forms.push(formData)
          console.log("forms=======", forms)
        })
        return {forms: forms, lastVisible: lastVisible}
      })

    },
    async searchForms ({ dispatch, commit }, data) {
      var forms = []
      let formsQuery
      console.log(data.groupId, data.filters.form)
      // formsQuery = await firebase.firestore().collection('companies').doc(data.companyId).collection('groups').doc(data.groupId).collection('forms').doc(data.filters.form).collection('submissions')
      formsQuery = await firebase.firestore().collectionGroup('submissions').where('groupId', '==', data.groupId)


      for (var filter in data.filters) {
        if (data.filters[filter] != null && data.filters[filter] !== '') {
          // console.log(filter, data.filters[filter])

          if (['dateRange'].includes(filter)) {

            let startDate = new Date(data.filters[filter].start)
            let endDate = new Date(data.filters[filter].end)
            endDate.setHours(24, 0, 0)

            // if (diffDays === 0) {
            //   labelsQuery = labelsQuery.where('createdAt', '==', startDate)
            // } else {


            formsQuery = formsQuery.where('createdAt', '>=', startDate)
            formsQuery = formsQuery.where('createdAt', '<=', endDate)
          } else if (filter === 'users') {
            if (data.filters[filter].length > 0) {
              var users = []
              data.filters[filter].forEach(user => {
                users.push(user.value)
              })
              formsQuery = formsQuery.where('userId', 'in', users)
            }
          } else {
            if (filter === "form"){
              formsQuery = formsQuery.where("formId", '==', data.filters[filter])
            } else if (data.filters[filter] != null) {

              formsQuery = formsQuery.where(filter, '==', data.filters[filter])
            }
          }
        }
      }
      // if (diffDays !== 0) {

      // }

      return formsQuery.orderBy('createdAt', 'desc').limit(31).get().then(function (querySnapshot) {

        firebase.analytics().logEvent("doc_fetch", {
          count: querySnapshot.docs.length,
          type: "FORM",
          company_id: data.companyId
        })

        if (querySnapshot.docs.length > 0) {
          var lastVisible = querySnapshot.docs[querySnapshot.size - 1]
        }
        /* eslint-disable */
        querySnapshot.forEach(async function (doc) {
          var groupData = doc.data()

          groupData.id = doc.id
          groupData.createdAtFormatted =  moment(String(groupData.createdAt.toDate())).format('DD/MM/YYYY kk:mm')
          forms.push(groupData)
        })
        return {forms: forms, lastVisible: lastVisible}
      })
    }
  },
  plugins: [vuexLocal.plugin]

})



// WEBPACK FOOTER //
// ./src/store.js